// src/services/tagService.js
import api from '../utils/api'; // Your API instance

const TAG_BASE_URL = '/tags';

const tagService = {
  // Get all tags with pagination, filtering, and search
  getTags: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      // Add pagination
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      
      // Add search
      if (params.search) queryParams.append('search', params.search);
      
      // Add filters
      if (params.type) queryParams.append('type', params.type);
      if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
      
      // Add sorting
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

      const response = await api.get(`${TAG_BASE_URL}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get single tag by ID
  getTagById: async (id) => {
    try {
      const response = await api.get(`${TAG_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get tag by slug
  getTagBySlug: async (slug) => {
    try {
      const response = await api.get(`${TAG_BASE_URL}/slug/${slug}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Create new tag
  createTag: async (tagData) => {
    try {
      const response = await api.post(TAG_BASE_URL, tagData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update tag
  updateTag: async (id, tagData) => {
    try {
      const response = await api.put(`${TAG_BASE_URL}/${id}`, tagData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Delete tag
  deleteTag: async (id) => {
    try {
      const response = await api.delete(`${TAG_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get tag usage statistics
  getTagStats: async (id) => {
    try {
      const response = await api.get(`${TAG_BASE_URL}/${id}/stats`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Bulk delete tags
  bulkDeleteTags: async (ids) => {
    try {
      const response = await api.delete(`${TAG_BASE_URL}/bulk`, { data: { ids } });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get popular tags
  getPopularTags: async (limit = 20) => {
    try {
      const response = await api.get(`${TAG_BASE_URL}/popular?limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Merge tags
  mergeTags: async (sourceTagId, targetTagId) => {
    try {
      const response = await api.post(`${TAG_BASE_URL}/merge`, {
        sourceTagId,
        targetTagId,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
};

export default tagService;